import styles from './RoasChart.module.scss';

export interface RoasChartProps {
  data: { date: string; roas: number }[];
  className?: string;
}

/**
 * ROAS over time line chart using Recharts.
 */
export function RoasChart({ className }: RoasChartProps) {
  return (
    <div className={className}>
      <div className={styles.container}>
        <p>ROAS chart coming soon.</p>
      </div>
    </div>
  );
}
